import { Topbar } from '../../components/Topbar/Topbar';
import { Badge, Container, ListGroup, ListGroupItem } from 'react-bootstrap';
import { Footer } from '../../components/Footer/Footer';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { useEffect, useState } from 'react';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { parseDuration } from '../../utils/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward, faCrown, faMedal } from '@fortawesome/free-solid-svg-icons';
import './Stats.scss';
import NumberFormat from 'react-number-format';
import { FormattedNumber } from '../../components/FormattedNumber/FormattedNumber';
import { Copyable } from '../../components/Copyable/Copyable';
import { Title } from '../../components/Title/Title';

const StatsComponent = () => {
  const { getStats } = useFirebase();
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState<any>({
    mostViewed: [],
    mostClicked: [],
  });

  useEffect(() => {
    setLoading(true);
    getStats()
      .then(setStats)
      .finally(() => setLoading(false));
  }, []);

  const VideoRow = ({ videoStat, i, children }) => (
    <ListGroupItem variant={['warning', 'info', 'secondary'][i] || 'dark'}>
      <div className={'d-flex flex-column mb-2'}>
        <h5 className={'mb-0 stat-video-title'}>
          {i < 3 && (
            <span className={['text-warning', 'text-info', 'text-secondary'][i] + ' mr-1'}>
              <FontAwesomeIcon fixedWidth={true} icon={[faCrown, faMedal, faAward][i]} />
            </span>
          )}
          {i >= 3 && (
            <Badge variant={'light'} className={'mr-1'}>
              {i + 1}
            </Badge>
          )}
          {videoStat.video.title}
        </h5>
        <small>
          <Copyable text={videoStat.id} />
          {!!videoStat.video.author && <span className={'ml-1'}>&ndash; {videoStat.video.author}</span>}
        </small>
      </div>
      {children}
    </ListGroupItem>
  );

  if (loading) return <FullscreenLoader />;

  return (
    <>
      <Title>Statistiche</Title>

      <div style={{ marginBottom: '72px' }}>
        <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
          <Topbar />
        </div>
      </div>

      <Container className={'my-5'}>
        <div className={'display-4'}>Statistiche</div>
        <div className={'mt-4 d-flex flex-column flex-sm-row'}>
          <div className={'w-sm-50'}>
            <h3>I 10 video più visti</h3>
            <ListGroup className={'mt-3'}>
              {stats.mostViewed.map((videoStat, i) => (
                <VideoRow videoStat={videoStat} i={i} key={videoStat.id}>
                  <div>
                    <span>Tempo di visione totale:</span>
                    <strong className={'mx-1'}>{parseDuration(videoStat.totalViews * 1000)}</strong>
                    <span>(da parte di</span>
                    <FormattedNumber className={'mx-1'} value={videoStat.count} />
                    <span>utenti)</span>
                  </div>
                </VideoRow>
              ))}
            </ListGroup>
          </div>

          <div className={'w-sm-50 ml-0 ml-sm-3 mt-3 mt-sm-0'}>
            <h3>I 10 video più cliccati</h3>
            <ListGroup className={'mt-3'}>
              {stats.mostClicked.map((videoStat, i) => (
                <VideoRow videoStat={videoStat} i={i} key={videoStat.id}>
                  <div>
                    <span>Numero di aperture:</span>
                    <strong>
                      <FormattedNumber className={'mx-1'} value={videoStat.openings} />
                    </strong>
                    <span>(da parte di</span>
                    <FormattedNumber className={'mx-1'} value={videoStat.count} />
                    <span>utenti)</span>
                  </div>
                </VideoRow>
              ))}
            </ListGroup>
          </div>
        </div>
      </Container>

      <Footer />
    </>
  );
};

export default StatsComponent;
